module.exports = __webpack_public_path__ + "02_long_gold.45ad7bd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_long_gold.png
// module id = zcDQ
// module chunks = 0